import { AuditLogMaintenanceConstant } from "presentation/constant/AuditLog/AuditLogMaintenanceConstant";
import { useAuditLogMaintenanceVM } from "presentation/hook/AuditLog/useAuditLogMaintenanceVM";
import { HeaderTitle } from "presentation/view/components/HeaderWithBackButton/HeaderTitle";
import { memo, useCallback } from "react";
import { IconButton } from "veronica-ui-component/dist/component/core";
import { Sidebarheader, StyledAction } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const AuditLogTitleBar: React.FC = () => {
    const auditLogVM = useAuditLogMaintenanceVM();


    const handleSearch = useCallback(async () => {
        auditLogVM.onSearchClick();
    }, [auditLogVM]);


    return <Sidebarheader style={{ width: '100%', display: "flex", alignItems: "center" }}>
        <HeaderTitle>{AuditLogMaintenanceConstant.TITLE}</HeaderTitle>
        <StyledAction className="tm-animated-wrapper">
            <IconButton fileName='Icon-search' disabled={false} size='medium' toolTipText={'Search'} toolTipArrow={false} onClick={handleSearch} />
        </StyledAction>
    </Sidebarheader>
}

export default memo(AuditLogTitleBar);